<template>
<div class="bg-secondary relative">
            <div class="flex flex-wrap w-full">
              <div
                class="h-64 w-64 bg-cover bg-center hidden lg:block "
                style="background-image: url('/img/manwithtablet.jpg')">

              </div>
              <div class="w-3/4 m-auto text-white text-center">

                  <div class="flex lg:w-3/4 m-auto border-b mb-8 pb-5 flex-col lg:flex-row">
                    <div v-for="item of collection" :key="item.caption" class="lg:w-1/3 text-center flex flex-row lg:flex-col">
                      <div><img :src="item.imgSrc" :alt="item.caption" class="w-16 h-16 m-auto" /></div>
                      <div>{{item.caption}}</div>
                    </div>
                  </div>
                  <a href="//app.who-afro-mlm.com" target="_blank" class="px-5 p-2 rounded bg-action hover:bg-action-dark focus:outline-none focus:shadow-outline text-sm text-white">
                  {{$t('workshops.go_to')}}
                  <i class="mdi mdi-arrow-right ml-5"></i></a>

      

              </div>
              
            </div>
          </div>


</template>

<script>
import ArrowRight from "vue-material-design-icons/ArrowRight.vue";

export default {
  components: {
    ArrowRight
  },
  name: "online-curriculum",

  data: () => ({
    collection: [
      {
        imgSrc: require("../assets/icon-06-samecontent.svg"),
        caption: "Same content as the workshops"
      },
      {
        imgSrc: require("../assets/icon-07-selfpaced.svg"),
        caption: "Self-paced learning"
      },
      {
        imgSrc: require("../assets/icon-08-modular.svg"),
        caption: "Highly modular"
      }
    ]
  })
};
</script>
